<template lang="pug">
  .box-header-top
    header.front.bg-light#stickyFront.sticky-front-top
      nav.navbar.navbar-light.navbar-expand-lg
        .container
          .col-md-12
            a.navbar-brand
              img(:src="icon" v-if="icon !== undefined && icon !== null && icon.length > 0")
              img(src="../../../assets/images/faces/ic_AvatarDefault@2x.png" v-else)
            #navbarCollapse.navbar-collapse
              ul.nav.navbar-nav.navbar-right.ml-auto
                li.nav-item(v-if="$store.getters.user === null")
                  a.nav-link.brown(@click="onRegister") {{$t("register.title")}}
                li.nav-item(v-if="$store.getters.user === null")
                  a.nav-link.blue(@click="onLogin") {{$t("login.title")}}
                li.nav-item(v-if="$store.getters.user !== null")
                  .item-info-login.desktop(@click="onAccount") 
                    span {{$t("home.hi")}}
                    p(v-if="lstInfo != null") {{lstInfo.fullname}}
                  .item-img-login(@click="onAccount")
                    img(:src="lstInfo.avatar" v-if="lstInfo && lstInfo.avatar !== undefined && lstInfo.avatar !== null && lstInfo.avatar.length > 0")
                    img(src="../../../assets/images/home/swarm.svg" v-else)
            .clearfix
</template>
<script>
import RegisterModal from '../../../components/Account/RegisterModal'
import gql from 'graphql-tag'
import graphql from '../../Model/graphqlfront'
import store from '../../../store'
import LoginModal from '@/components/Account/LoginModal'
export default {
  props: {
    icon: String
  },
  data() {
    return {
      message: this.$t('home.comming_soon'),
      year: new Date().getFullYear()
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    onRegister(e, email, fullname) {
      this.isOpen = false
      let scrollTop = this.$mycontroller.getScrollTop(window)
      var url = this.getCurrentLink()
      try {
        this.$modal.show(RegisterModal, {
          newEmail: email,
          newFullName: fullname,
          selectedTeacher: false,
          selectedStudent: false,
          newName: this.$route.name,
          newFrontTop: scrollTop,
          url: url
        }, {
          // width: '43%',
          height: 'auto',
          classes: ['col-6'],
          adaptive: true,
          resize: true,
          clickToClose: false
        })
      } catch (e) {}
    },
    onLogin() {
      this.isOpen = false
      if (!this.$store.getters.isLoggedIn) {
        try {
          this.$store.commit('setIsHomePage', true)
          let scrollTop = this.$mycontroller.getScrollTop(window)
          var params = this.$route.params
          params = Object.assign(params, {name: this.$route.name})
          params = Object.assign(params, {front_top: scrollTop})
          params = Object.assign(params, {url: this.getCurrentLink()})
          this.$modal.show(LoginModal, {params: params}, {
            // width: '43%',
            height: 'auto',
            classes: ['col-6'],
            adaptive: true,
            resize: true,
            clickToClose: false
          })
        } catch (e) {}
      }
    },
    onAccount() {
      this.isOpen = false
      this.$store.commit('setIsHomePage', false)
      this.$store.commit('setIsLoggedIn', true)
      this.$router.push({name: 'Account'})
    },
    getCurrentLink() {
      var path = this.$route.path
      if (path.length > 0 && path[0] === '/') path = this.$mycontroller.removeByIndexFromString(path, 1)
      var link = window.location.origin + '/' + this.$router.resolve({path: '/'}).href
      return link + path
    }
  },
  apollo: {
    lstInfo: {
      query: gql(graphql.GET_USER_PUBLIC),
      variables() {
        return {
          uid: store.getters.user
        }
      },
      update: data => {
        if (data.v_user_public.length === 0) return null
        return data.v_user_public[0]
      }
    }
  }
}
</script>
<style lang="scss">
html { scroll-behavior: smooth;}
  .front-landing-page{
    .box-header-top{min-height: 88px;
      header.front.bg-light{background:#FBF4D2;
        &.sticky-front-top{top:0;left: 0; width: 100%; position: fixed; z-index: 999;}
        .navbar.navbar-light{background: transparent; border: 0 none; padding:0;margin:0;
          .navbar-brand{width:60px; height: 60px; display: flex; justify-content: center; flex-direction: column; overflow: hidden; margin: 15px 0 auto 0; padding: 0;
            img{display: block; border-radius: 5px; max-width: 100%; height: auto;}
          }
          .navbar-collapse{margin-right: -15px;}
          .navbar-nav.ml-auto{margin: 24px 0;
            .nav-item{
              .item-info-login{float: left; margin-right: 10px;
                span{color: #4B2D15; font-size: 13px;text-align: right; display: block;}
                p{margin: 0;color: #9F6A28; text-align: right;}
              }
              .nav-link{text-transform:none;font-size:16px; padding: 10px 20px;color:#B1AE9E; cursor: pointer;
                &.brown{color:#9F6A28;}
                &.blue{color:#3A9F00;}
              }
              .item-img-login{float: left;margin-top: 5px;cursor: pointer;
                img{ width: 32px; height: 32px; padding: 7px; margin: 0 auto; max-width: 100%; background: #969FAD 0% 0% no-repeat padding-box; border-radius: 50%;}
              }
            }
            .divider{margin: 8px 20px 0;height: 25px; border-right: 2px solid #EDDFB9; }
          }
        }
      }
    }
  }
@media (min-width: 991px){
  .front-landing-page{
    header.front{
      .navbar{
        .container{ left: auto;}
      }
    }
  }
}
@media (max-width: 991px){
  .front-landing-page{
    header.front{
      .navbar{
        .navbar-brand{margin-left: 0 !important;}
        .navbar-collapse.mobile{z-index: 9999; position: fixed; right: auto;left: 0;height:100%; width:280px;background:#FBF4D2;padding-right:0;visibility:visible;
          .navbar-brand{display:block !important; line-height: initial; width:100%; padding:15px !important;border-bottom:1px solid #F7F0CF; margin-left: 0;}
        }
        .navbar-collapse{ transition: all 0.5s ease 0s;-webkit-transition: all 0.5s ease 0s;}
        .navbar-nav.ml-auto{
            &.navbar-right{float: right;}
            .nav-item{display: inline-block;
              .nav-link{color:#343A40 !important;}
              .nav-link.brown { color: #9F6A28 !important;}
              .nav-link.blue{color:#3A9F00 !important;}
              .item-info-login{padding-left: 20px;
                &.desktop{display: none;}
                p{text-align: center!important;}
              }
            }
            .divider{display: none;}
        }
        .overlay-menu{cursor:pointer; background: rgba(0, 0, 0, 0.5); position:fixed; width: 100%;height: 100%;left: 0;top: 0; z-index:10;}
        .navbar-toggle{display: block !important;margin:0;top:29px;}
        .close{display: block !important; position: absolute; top: 25px;right: 10px;font-size: 30px;color: #000;font-weight: initial;z-index:999;}
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// landing.vue?36b731d4